import { render } from "./NovaRequisicaoBalcao.vue?vue&type=template&id=cb14c970&scoped=true"
import script from "./NovaRequisicaoBalcao.vue?vue&type=script&lang=js"
export * from "./NovaRequisicaoBalcao.vue?vue&type=script&lang=js"

import "./NovaRequisicaoBalcao.vue?vue&type=style&index=0&id=cb14c970&scoped=true&lang=css"
import "./NovaRequisicaoBalcao.vue?vue&type=style&index=1&id=cb14c970&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb14c970"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QInput,QRadio,QField});
